import { render, staticRenderFns } from "./PartnerStoreMappingRegist.vue?vue&type=template&id=085046c4&"
import script from "./PartnerStoreMappingRegist.vue?vue&type=script&lang=js&"
export * from "./PartnerStoreMappingRegist.vue?vue&type=script&lang=js&"
import style0 from "./PartnerStoreMappingRegist.vue?vue&type=style&index=0&id=085046c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports